import React, { useEffect, useRef, useState } from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import { IoIosArrowForward } from "react-icons/io"

import useCurrentWidth from "../hooks/useCurrentWidth";
import Target from "../components/Cursor/target"
import PageTransition from "../components/page-transition";
import Layout from "../components/layout"
import SEO from "../components/seo"
import HomeWorksCarousel from "../components/home-works-carousel";
import HomeWorkItem from "../components/home-work-item";
import DribbleShots from "../components/dribble_shots";

import worksData from "../data/home-works";
import './../styles/home.scss';

const Banner = () => (
  <div className="hp-banner">
    <div className="hp-container">
      <div className="hp-banner-container">
        <h1 className="title">
          I Design nice things for <span>humans</span>
        </h1>
        <div className="description">
          <h4>
            <span className="greet">
              Hey{" "}
              <span role="img" aria-label="Hand wave">
                👋
                </span>
            </span>
            <br />
              I'm Hariprasath, a UX/UI Designer from Chennai. I've 1+ year
              Experience in UX/UX desidning fiend and I have 2+ years Experience
              Graphics Designer field. I have built various human-centered
              digital experiences for businesses.
            </h4>
          <Target>
            <PageTransition className="aboutMeLink" to="/about">
              <h5>About me</h5>
              <IoIosArrowForward size={20} className="arrow" />
            </PageTransition>
          </Target>
        </div>
      </div>
    </div>
  </div>
);

const ProjectsTitle = () => (
  <h1 className="hp-title">Features Projects</h1>
);

const Works = () => {
  let width = useCurrentWidth();
  const isMounted = useRef(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentIndexRef = useRef(0);
  const [scrollTopOffset, setScrollTopOffset] = useState({
    scroll: 0,
    top: 0
  });
  const rootRef = useRef(null);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    }
  });

  const onScroll = (ev) => {
    if (isMounted.current) {
      setScrollTopOffset({
        scroll: ev.offset.y,
        top: rootRef.current.offsetTop
      });
    }
  };

  const setCurrentItem = (index) => {
    if (index !== currentIndexRef.current && isMounted.current) {
      setCurrentIndex(index);
    }
    currentIndexRef.current = index;
  };

  return (
    <div ref={rootRef} id="hp-works">
      {worksData.map((work, index) => <HomeWorkItem
        key={index} {...work}
        isFirst={index === 0}
        isLast={worksData.length === index + 1}
        currentItem={worksData[currentIndex]}
        setCurrentItem={() => setCurrentItem(index)}
        scrollTopOffset={scrollTopOffset}
      />)}
      {width < 900 ? null : <HomeWorksCarousel onScroll={onScroll} currentIndex={currentIndex} works={worksData} />}
    </div>
  )
};

const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query {
      bgLogo: file(relativePath: { eq: "icon-bg.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, maxHeight: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Layout>
      <SEO title="Home" />
      <div className="hp-bg-img-container">
        <Img
          fluid={data.bgLogo.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
        />
      </div>
      <Banner />
      <ProjectsTitle />
      <Works />
      <DribbleShots />
    </Layout>
  )
}

export default IndexPage
